module.exports = __webpack_public_path__ + "img/404_image.530692a7.png";